import { setGADataLayer } from 'analytics'

export function trackGA4NavigationEvent(label, path, parent) {
    const data = {
        event: 'menu_nav',
        options: {
            eventInfo: {
                'eventInfo.navElement': parent,
                'eventInfo.navSubelement': label,
                'eventInfo.link': new URL(path, location.origin).href,
            },
        },
    }

    setGADataLayer(data)
}
